//dynamic product recomendations
window.onload = function(e){
  const productRecomendationBody = document.querySelector('#product_recomendation_body');
  //if container
  if(productRecomendationBody != null){
    const productRecomendationSection = document.querySelector('.product-recomendations');
    const wrapper = document.querySelector('.slider-parent');
    const url = productRecomendationSection.dataset.url;
    productRecomendationBody.innerHTML = '';
    //ASYNC FUNCTION
    //This function returns a promise
    const getProducts = async () => {
      try {
        recommendURL = url.trim();// remove the unwanted whitespace
        const response = await fetch(recommendURL);//this operation takes some time, so we wait
        //This will return a new promise so we can call .then on the response
        const products = await response.json();
        //we pass the retruned data from products into the function
        return products;
        // console.log('Products loaded', products);
      } catch(err){
        console.log(new Error(`Unable to load products ${err.message}`));
      }
    }
    //END ASYNC FUNCTION
    //this is the data from the response
    getProducts()
    .then(({products}) => {
      //if image is equal to or greater than 1
      if(products.length > 0) {
        //for each product
        products.forEach((product, index) => {
          //Check if image exisits, otherwise render placeholder
          const productImage = product.images.length;
          const productVariant = product.variants[0];

          //url conditional
          const url = product.variants.length > 1 ? `${product.url}?variant=${product.variants[0].id}` : `${product.url}`;
          // console.log(url);

          //image conditional
          const imageChecked = productImage > 0 ?
          `<a href="${url}" tabindex="-1">
            <div class="reveal img-fluid recomendation-image">
              <img class="img-fluid lazyload bg-white" data-src="${product.images[0]}" alt="${product.title}" width="1000px" height="1000px" loading="lazy"/>
            </div>
          </a>` : `${window.strings.placeholder}`;
          //HTML template literal elements to be added to product_recomendation_body
          const productRow = `
          <div class="col-md-4 col-lg-4 col-sm-12 col-xs-6 rec-products" tabindex="-1" data-value="">
            <div class="product-item mb-0 wow fadeIn rec-img card-wrapper d-block">
              <div class="product-thumb" tabindex="0">
                ${product.compare_at_price > product.price ? `<div class="position-absolute product-alerts"><span class="badge badge-sale badge-pill badge-primary mb-0 mr-0 on-sale">${window.theme.onSale}</span></div>` : ""}
                ${imageChecked}
              </div>
              <div class="product-details-card py-3 px-2 d-flex">
                <a href="${url}">
                  <div class="product-content card-information">
                    <div class="card-information__wrapper mb-2">
                      <span class="card-information__text h5 mr-0">${product.title}</span>
                    </div>
                  </div>
                </a>
                <div class="product-content main-content options-styles-unit-price">
                  <div class="d-inline-flex">
                    <span class="card-information__text h5 text-decoration-none">
                      <input type="hidden" name="converted_price" value="${Shopify.formatMoney(product.price, window.theme.moneyFormat)}" >
                      <span class="js-price js-price-recommend money money_price" data-default-price="">
                      ${product && product.price_varies ? `from ` : ""} ${Shopify.formatMoney(product.price, window.theme.moneyFormat)}
                      </span>
                      ${product.compare_at_price > product.price ? `<span class="money"><s class="ml-1 js-price-compare js-price-recommend-compare money money_price">${Shopify.formatMoney(product.compare_at_price, window.theme.moneyFormat)}</s></span>` : ""}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          `;
          //append productRow to DOM
          productRecomendationBody.insertAdjacentHTML('afterbegin', productRow);
        });
      }
      if(products.length < 3){
        productRecomendationBody.classList.add('w-100');
      }
    })
    .catch((err) => {
      console.log('Rejected', err);
    });
  }
};
//end dynamic product recomendations
